import { NavItem } from '../interfaces/NavBar';
import { useAboutUsItems } from './useAboutUsItems';
import { useCmsHeaderItems } from './useCmsHeaderItems';
import { useMyEsimItem } from './useESIMItem';
import { useHelpItems } from './useHelpItems';
import { useMyAccountItem } from './useMyAccountItem';
import { useStoreLocatorItem } from './useStoreLocatorItem';

export const useNavbarItems = (): {
  navbarItems: NavItem[];
  burgerMenuItems: NavItem[];
  contactBarItems: NavItem[];
} => {
  const helpItem = useHelpItems();
  const aboutUsItem = useAboutUsItems();
  const myESIM = useMyEsimItem();
  const myAccount = useMyAccountItem();
  const storeLocator = useStoreLocatorItem();
  const cmsHeaderItems = useCmsHeaderItems();

  if (cmsHeaderItems) {
    return {
      navbarItems: [...cmsHeaderItems.menuItems, myESIM, myAccount],
      burgerMenuItems: [
        ...cmsHeaderItems.menuItems,
        ...cmsHeaderItems.contactBarItems,
        myESIM,
        myAccount,
      ],
      contactBarItems: cmsHeaderItems.contactBarItems,
    };
  }

  return {
    navbarItems: [aboutUsItem, myESIM, myAccount],
    burgerMenuItems: [aboutUsItem, helpItem, storeLocator, myESIM, myAccount],
    contactBarItems: [helpItem],
  };
};
